/* eslint-disable import/prefer-default-export */
export const getUserDisplayNameFromEmail = (email) => {
  if (!email) {
    return null;
  }
  return email.split('@')[0] ? email.split('@')[0].toUpperCase().replace('.', ' ') : email;
};



// WEBPACK FOOTER //
// ./src/helpers/format.js